export default "__VITE_ASSET__CuvwKwbI__"